import PhoneInput, {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import { withRouter } from "react-router";
import firebase from "firebase";
import { Button, Input } from "antd";
import React, { useState, useEffect } from "react";
import fire from "./fire";
// import advisorRoleCheck from "./advisorRoleCheck"
import "antd/dist/antd.css";
import "react-phone-number-input/style.css";

const PhoneLogin = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [receivedOtp, setReceivedOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  // checks if user logged in on page load and
  // checks validity of phone number
  useEffect(() => {
    // checkLogin();
    checkPhoneNumber();
  });

  //sign function
  const signInWithPhoneNumber = (appVerifier) =>
    fire
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function (confirmationResult) {
        setReceivedOtp(true);
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
      })
      .catch(function (error) {
        setPhoneError("Refresh Page : " + error);
      });
  //clears input display errors
  const clearErrors = () => {
    setPhoneError("");
  };

  //checks if user is already logged in
  //can be moved to a separate file and can return a boolean to check
  const checkLogin = () => {
    fire.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        props.history.push("/");
      } else {
        // No user is signed in.
      }
    });
  };

  //checks validity of phone number and disables the button if the number is invalid
  const checkPhoneNumber = () => {
    if (isPossiblePhoneNumber(phoneNumber) && isValidPhoneNumber(phoneNumber)) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  //handles the login with phone number
  //checks if the number is valid and then moves on to login the user with firebase
  //initialises captcha
  const handlePhoneLogin = (event) => {
    clearErrors();
    event.preventDefault();
    setLoading(true);
    //creates captcha
    //can make it into a function to read phone number and return its validity
    if (isPossiblePhoneNumber(phoneNumber) && isValidPhoneNumber(phoneNumber)) {
      window.appVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
        }
      );
      //verifies captcha and logs in user
      const appVerifier = window.appVerifier;
      signInWithPhoneNumber(appVerifier);
    } else {
      setPhoneError("Enter a valid Number");
    }
  };

  //verifies the otp submit process
  const onVerifyCodeSubmit = async (event) => {
    event.preventDefault();
    const verificationId = otp;
    window.confirmationResult
      .confirm(verificationId)
      .then(async function (result) {
        // User signed in successfully.
        var user = result.user;
        user.getIdToken().then((idToken) => {
          // props.history.push("/");
        });
        // advisorRoleCheck();
        const db = fire.firestore();
        const id = fire.auth().currentUser.uid;
        const userSnapshot = await db.collection("users").doc(id).get();
        
        if (userSnapshot.exists) {
          if (
            userSnapshot.data().role == "admin" ||
            userSnapshot.data().role == "advisor"
          ) {
            const statsSnapshotRef = await db
              .collection("global")
              .doc("advisoryStats")
              .collection("advisorStats")
              .doc(id);
            const statsSnapshot = await statsSnapshotRef.get();
            if (!statsSnapshot.exists) {
              const newStatsDoc = {
                name: userSnapshot.data().name,
                profileImageUrl: userSnapshot.data().profileImage,
                activatedAdvises: 0,
                advisorId: userSnapshot.data().advisorId,
                denominator: 0,
                targetHit: 0,
                totalAdvises:0,
              }
              statsSnapshotRef.set(newStatsDoc)
            } 
            props.history.push({
              pathname: "/",
              search: "?query=abc",
              state: { detail: userSnapshot.data() },
            });
          } else {
            fire
              .auth()
              .signOut()
              .then(function () {
                window.alert("Error:Unauthorized User");
                props.history.push("/");
              });
          }
        }
        //if user role is advisor push page to dash
        // else push page to marketfeed login or download app page
      })
      .catch(function (error) {
        // User couldn't sign in (bad verification code?)
        // setPhoneError(error);
        console.error("Error while checking the verification code", error);
        window.alert("Error while checking the verification code");
      });
  };

  return (
    <section>
      <div className="adviseContainer">
        {!receivedOtp ? (
          <div
            style={{
              background: "rgba(255,255,255)",
              margin: 10,
              padding: 10,
              height: 180,
              borderRadius: 5,
            }}
          >
            <label style={{ fontSize: 20, fontWeight: 700 }}>
              Login To Marketfeed Advisory
            </label>
            <br />
            <label style={{ fontSize: 12, fontWeight: 400 }}>
              10 Digit Mobile Number
            </label>
            <div style={{ border: "1px solid #DCDCDC", borderRadius: 5 }}>
              <PhoneInput
                className="phoneInput"
                defaultCountry="IN"
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={setPhoneNumber}
              />
            </div>
            <p className="errorMsg">{phoneError}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                id="sign-in-button"
                loading={loading}
                onClick={handlePhoneLogin}
                disabled={isDisabled}
              >
                Get OTP
              </Button>
            </div>
          </div>
        ) : (
          <div
            style={{
              background: "rgba(255,255,255)",
              margin: 10,
              padding: 10,
              height: 125,
              borderRadius: 5,
            }}
          >
            <label style={{ display: "flex", justifyContent: "center" }}>
              Enter OTP
            </label>
            <Input
              type="text"
              autoFocus
              required
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <p className="errorMsg">{phoneError}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="primary"
                onClick={onVerifyCodeSubmit}
                htmlType="submit"
              >
                Submit OTP
              </Button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default withRouter(PhoneLogin);
